import React, { useContext, useState, useEffect } from "react";
import {
  Box,
  Button,
  Flex,
  HStack,
  Input,
  Text,
  SimpleGrid,
  Badge,
  Icon,
  Select,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  useToast,
  Radio,
  RadioGroup,
  Stack,
} from "@chakra-ui/react";
import { CheckIcon } from "@chakra-ui/icons";
import {
  FaMapMarkerAlt,
  FaPlus,
  FaTrash,
  FaCheckCircle,
  FaLock,
  FaTruck,
} from "react-icons/fa";
import { Link, Navigate } from "react-router-dom";
import { CartContext } from "../Context/CartContext";
import { apiUrl } from "../ApiUrl/ApiUrl";

function DeliveryPage() {
  const toast = useToast();
  const uid = localStorage.getItem("uid");

  const { cartData = [], globalAddress, setGlobalAddress } = useContext(CartContext);

  const [addresses, setAddresses] = useState([]);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [showNewAddressForm, setShowNewAddressForm] = useState(false);
  const [forward, setForward] = useState(false);

  const [totalDescPrice, setTotalDescPrice] = useState(0);
  const [totalOrigPrice, setTotalOrigPrice] = useState(0);
  const [gst, setGst] = useState(0);

  const [address, setAddress] = useState({
    name: "",
    number: "",
    pincode: "",
    email: localStorage.getItem("email") || "",
    address: "",
    city: "",
    state: "",
    uid: uid,
  });

  const states = [
    "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
    "Delhi (NCT)", "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand",
    "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya",
    "Mizoram", "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu",
    "Telangana", "Tripura", "Uttarakhand", "Uttar Pradesh", "West Bengal",
  ];

  const fetchAddresses = () => {
    if (uid) {
      fetch(`${apiUrl}/public/getAddressByUid?uid=${uid}`)
        .then((res) => res.json())
        .then((data) => {
          if (Array.isArray(data)) {
            setAddresses(data);
            if (data.length > 0 && !selectedAddressId) {
              const first = data[0];
              setSelectedAddressId(first.id);
              setGlobalAddress({
                Name: first.name,
                Address: first.address,
                City: first.city,
                Pincode: first.pincode,
                State: first.state,
                Number: first.number,
                Email: first.email,
              });
            }
          }
        })
        .catch((err) => console.error("Error fetching addresses:", err));
    }
  };

  const fetchPrice = async () => {
    if (!uid) return;
    try {
      const res = await fetch(`${apiUrl}/public/getAllCartById?uid=${uid}`);
      const data = await res.json();
      if (Array.isArray(data)) {
        const total = data.reduce((sum, item) => sum + parseFloat(item.descprice || 0), 0);
        const totalG = data.reduce((sum, item) => sum + parseFloat(item.gst || 0), 0);
        const origTotal = data.reduce(
          (sum, item) => sum + (item.quantity || 1) * parseFloat(item.originalprice || 0),
          0
        );
        setTotalDescPrice(total);
        setGst(totalG);
        setTotalOrigPrice(origTotal);
      }
    } catch (err) {
      console.error("Error fetching price details:", err);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchAddresses();
    fetchPrice();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAddress((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectExistingAddress = (item) => {
    setSelectedAddressId(item.id);
    setGlobalAddress({
      Name: item.name,
      Address: item.address,
      City: item.city,
      Pincode: item.pincode,
      State: item.state,
      Number: item.number,
      Email: item.email,
    });
  };

  const handleDeleteAddress = async (id) => {
    if (window.confirm("Are you sure you want to remove this delivery address?")) {
      try {
        const res = await fetch(`${apiUrl}/public/deleteByid?id=${id}`, {
          method: "DELETE",
        });
        if (res.ok) {
          toast({
            title: "Address Removed",
            status: "info",
            duration: 2000,
            position: "top",
          });
          setAddresses((prev) => prev.filter((item) => item.id !== id));
        }
      } catch (err) {
        console.error("Error deleting address:", err);
      }
    }
  };

  const handleSaveNewAddress = async () => {
    if (!address.name || !address.number || !address.pincode || !address.address || !address.state) {
      toast({
        title: "Required Fields Missing",
        description: "Please fill in all address fields to proceed.",
        status: "warning",
        duration: 3000,
        position: "top",
      });
      return;
    }

    try {
      const response = await fetch(`${apiUrl}/public/saveOrUpdate`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(address),
      });

      if (!response.ok) throw new Error("Failed to save address");

      toast({
        title: "Address Saved",
        description: "Your delivery address has been stored successfully.",
        status: "success",
        duration: 2500,
        position: "top",
      });

      setGlobalAddress({
        Name: address.name,
        Address: address.address,
        City: address.city,
        Pincode: address.pincode,
        State: address.state,
        Number: address.number,
        Email: address.email,
      });

      setForward(true);
    } catch (err) {
      console.error("Error saving address:", err);
      toast({
        title: "Error",
        description: "Failed to save address. Please try again.",
        status: "error",
        duration: 3000,
        position: "top",
      });
    }
  };

  const handleContinueWithSelected = () => {
    if (!selectedAddressId && addresses.length > 0) {
      toast({
        title: "Select an Address",
        description: "Please select an address or add a new one to continue.",
        status: "warning",
        duration: 2500,
        position: "top",
      });
      return;
    }
    setForward(true);
  };

  if (forward) {
    return <Navigate to="/summary" />;
  }

  const sellingPrice = totalOrigPrice;
  const discount = Math.max(0, totalOrigPrice - totalDescPrice);
  const totalAmount = sellingPrice - discount + gst;

  return (
    <Box minH="85vh" bg="#F8FAFC" py={{ base: "4", md: "8" }} px={{ base: "3", md: "6", lg: "8" }}>
      <Box maxW="1360px" mx="auto">
        {/* Stepper Progress */}
        <Flex
          bg="white"
          p="3.5"
          rounded="xl"
          border="1px solid #E2E8F0"
          shadow="sm"
          mb="6"
          justify="space-around"
          align="center"
          fontSize="13px"
        >
          <Link to="/cart">
            <Flex align="center" gap="2" color="green.600" fontWeight="bold" cursor="pointer" _hover={{ opacity: 0.8 }}>
              <Box w="22px" h="22px" rounded="full" bg="green.500" color="white" display="flex" alignItems="center" justifyContent="center" fontSize="11px">
                ✓
              </Box>
              <Text display={{ base: "none", sm: "block" }}>1. Shopping Cart</Text>
            </Flex>
          </Link>
          <Box w="20px" h="2px" bg="#162237" />
          <Flex align="center" gap="2" color="#162237" fontWeight="bold">
            <Box w="22px" h="22px" rounded="full" bg="#162237" color="white" display="flex" alignItems="center" justifyContent="center" fontSize="11px">
              2
            </Box>
            <Text>2. Delivery Address</Text>
          </Flex>
          <Box w="20px" h="2px" bg="gray.200" />
          <Flex align="center" gap="2" color="gray.400">
            <Box w="22px" h="22px" rounded="full" bg="gray.200" color="gray.600" display="flex" alignItems="center" justifyContent="center" fontSize="11px">
              3
            </Box>
            <Text display={{ base: "none", sm: "block" }}>3. Order Review</Text>
          </Flex>
          <Box w="20px" h="2px" bg="gray.200" />
          <Flex align="center" gap="2" color="gray.400">
            <Box w="22px" h="22px" rounded="full" bg="gray.200" color="gray.600" display="flex" alignItems="center" justifyContent="center" fontSize="11px">
              4
            </Box>
            <Text display={{ base: "none", sm: "block" }}>4. Payment</Text>
          </Flex>
        </Flex>

        {/* Back Navigation Action */}
        <Flex justify="space-between" align="center" mb="4">
          <Link to="/cart">
            <Button
              size="sm"
              variant="ghost"
              color="#162237"
              _hover={{ bg: "gray.100" }}
              fontWeight="bold"
            >
              ← Back to Shopping Cart
            </Button>
          </Link>
          <Text fontSize="xs" color="gray.500">
            Need to edit items or quantities? Click back above.
          </Text>
        </Flex>

        {/* 2-Column Delivery Layout */}
        <SimpleGrid columns={{ base: 1, lg: 3 }} spacing={{ base: 6, lg: 8 }} alignItems="start">
          {/* Left Column: Address Selection & Form */}
          <Box gridColumn={{ lg: "span 2" }}>
            {/* Step 1: Login Status Card */}
            <Flex
              align="center"
              justify="space-between"
              p="4"
              bg="white"
              border="1px solid #E2E8F0"
              rounded="xl"
              shadow="sm"
              mb="4"
            >
              <Flex align="center" gap="3">
                <Box w="26px" h="26px" rounded="full" bg="green.500" color="white" display="flex" alignItems="center" justifyContent="center" fontSize="12px" fontWeight="bold">
                  ✓
                </Box>
                <Box>
                  <Text fontSize="13px" fontWeight="bold" color="gray.500" textTransform="uppercase">
                    Account
                  </Text>
                  <Text fontSize="14px" fontWeight="700" color="gray.900">
                    {localStorage.getItem("loginsetName") || "Authenticated"} ({localStorage.getItem("email") || "Customer"})
                  </Text>
                </Box>
              </Flex>
            </Flex>

            {/* Step 2: Address Selection Card */}
            <Box bg="white" border="1px solid #E2E8F0" rounded="2xl" p="6" shadow="sm" mb="4">
              <Flex justify="space-between" align="center" mb="5">
                <Flex align="center" gap="2.5">
                  <Box p="2" bg="blue.50" color="#2563EB" rounded="lg">
                    <Icon as={FaMapMarkerAlt} boxSize="16px" />
                  </Box>
                  <Box>
                    <Text fontSize="17px" fontWeight="800" color="gray.900">
                      Select Delivery Address
                    </Text>
                    <Text fontSize="12.5px" color="gray.500">
                      Where should we deliver your legal literature and materials?
                    </Text>
                  </Box>
                </Flex>

                <Button
                  size="sm"
                  variant="outline"
                  colorScheme="blue"
                  leftIcon={<Icon as={FaPlus} />}
                  onClick={() => setShowNewAddressForm(!showNewAddressForm)}
                  rounded="lg"
                  fontSize="12.5px"
                >
                  {showNewAddressForm ? "View Saved" : "Add New Address"}
                </Button>
              </Flex>

              {/* Saved Addresses Cards */}
              {!showNewAddressForm && (
                <Box>
                  {addresses.length === 0 ? (
                    <Box p="6" bg="gray.50" rounded="xl" textAlign="center" border="1px dashed #CBD5E1">
                      <Text fontSize="14px" color="gray.600" mb="3">
                        No saved delivery addresses found.
                      </Text>
                      <Button
                        size="sm"
                        bg="#0F172A"
                        color="white"
                        _hover={{ bg: "#1E293B" }}
                        onClick={() => setShowNewAddressForm(true)}
                        rounded="lg"
                      >
                        Enter Delivery Address
                      </Button>
                    </Box>
                  ) : (
                    <Stack spacing="3">
                      {addresses.map((item) => {
                        const isSelected = selectedAddressId === item.id;
                        return (
                          <Box
                            key={item.id}
                            p="4"
                            rounded="xl"
                            border="2px solid"
                            borderColor={isSelected ? "#2563EB" : "#E2E8F0"}
                            bg={isSelected ? "#EFF6FF" : "white"}
                            transition="all 0.2s"
                            cursor="pointer"
                            onClick={() => handleSelectExistingAddress(item)}
                          >
                            <Flex justify="space-between" align="flex-start">
                              <Flex gap="3" align="flex-start">
                                <Radio isChecked={isSelected} colorScheme="blue" mt="1" />
                                <Box>
                                  <Flex align="center" gap="2" mb="1">
                                    <Text fontSize="15px" fontWeight="700" color="gray.900">
                                      {item.name}
                                    </Text>
                                    <Badge colorScheme="blue" fontSize="11px" px="1.5" rounded="md">
                                      {item.number}
                                    </Badge>
                                  </Flex>
                                  <Text fontSize="13px" color="gray.600" lineHeight="1.5">
                                    {item.address}, {item.city} - {item.pincode}
                                  </Text>
                                  <Text fontSize="12.5px" fontWeight="600" color="gray.700" mt="0.5">
                                    {item.state}
                                  </Text>
                                </Box>
                              </Flex>

                              <Button
                                size="xs"
                                variant="ghost"
                                colorScheme="red"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDeleteAddress(item.id);
                                }}
                              >
                                <Icon as={FaTrash} />
                              </Button>
                            </Flex>

                            {isSelected && (
                              <Button
                                mt="3"
                                size="sm"
                                bg="#2563EB"
                                color="white"
                                _hover={{ bg: "#1D4ED8" }}
                                rounded="lg"
                                onClick={handleContinueWithSelected}
                              >
                                Deliver to this Address →
                              </Button>
                            )}
                          </Box>
                        );
                      })}
                    </Stack>
                  )}
                </Box>
              )}

              {/* Add New Address Form */}
              {showNewAddressForm && (
                <Box p="5" bg="gray.50" rounded="xl" border="1px solid #E2E8F0">
                  <Text fontSize="15px" fontWeight="700" color="gray.900" mb="4">
                    New Address Details
                  </Text>

                  <SimpleGrid columns={{ base: 1, sm: 2 }} spacing="3.5" mb="4">
                    <Box>
                      <Text fontSize="12.5px" fontWeight="600" color="gray.700" mb="1">
                        Full Name / Chamber
                      </Text>
                      <Input
                        name="name"
                        value={address.name}
                        onChange={handleChange}
                        placeholder="Adv. Rajesh Sharma"
                        rounded="lg"
                        bg="white"
                        fontSize="13.5px"
                      />
                    </Box>

                    <Box>
                      <Text fontSize="12.5px" fontWeight="600" color="gray.700" mb="1">
                        Contact Phone Number
                      </Text>
                      <Input
                        name="number"
                        value={address.number}
                        onChange={handleChange}
                        placeholder="10-digit mobile number"
                        rounded="lg"
                        bg="white"
                        fontSize="13.5px"
                      />
                    </Box>

                    <Box gridColumn={{ sm: "span 2" }}>
                      <Text fontSize="12.5px" fontWeight="600" color="gray.700" mb="1">
                        Complete Address (Chamber, Floor, Street, Landmark)
                      </Text>
                      <Input
                        name="address"
                        value={address.address}
                        onChange={handleChange}
                        placeholder="Chamber No., High Court Compound / Office"
                        rounded="lg"
                        bg="white"
                        fontSize="13.5px"
                      />
                    </Box>

                    <Box>
                      <Text fontSize="12.5px" fontWeight="600" color="gray.700" mb="1">
                        City / District
                      </Text>
                      <Input
                        name="city"
                        value={address.city}
                        onChange={handleChange}
                        placeholder="Nagpur"
                        rounded="lg"
                        bg="white"
                        fontSize="13.5px"
                      />
                    </Box>

                    <Box>
                      <Text fontSize="12.5px" fontWeight="600" color="gray.700" mb="1">
                        PIN Code
                      </Text>
                      <Input
                        name="pincode"
                        value={address.pincode}
                        onChange={handleChange}
                        placeholder="440001"
                        rounded="lg"
                        bg="white"
                        fontSize="13.5px"
                      />
                    </Box>

                    <Box gridColumn={{ sm: "span 2" }}>
                      <Text fontSize="12.5px" fontWeight="600" color="gray.700" mb="1">
                        State
                      </Text>
                      <Select
                        name="state"
                        value={address.state}
                        onChange={handleChange}
                        rounded="lg"
                        bg="white"
                        fontSize="13.5px"
                        placeholder="Select your State"
                      >
                        {states.map((s, idx) => (
                          <option key={idx} value={s}>{s}</option>
                        ))}
                      </Select>
                    </Box>
                  </SimpleGrid>

                  <Flex gap="3">
                    <Button
                      variant="outline"
                      onClick={() => setShowNewAddressForm(false)}
                      rounded="lg"
                    >
                      Cancel
                    </Button>
                    <Button
                      bg="#0F172A"
                      color="white"
                      _hover={{ bg: "#1E293B" }}
                      rounded="lg"
                      onClick={handleSaveNewAddress}
                    >
                      Save & Proceed to Review →
                    </Button>
                  </Flex>
                </Box>
              )}
            </Box>
          </Box>

          {/* Right Column: Price Details */}
          <Box position={{ lg: "sticky" }} top="90px">
            <Box bg="white" border="1px solid #E2E8F0" rounded="2xl" p="5" shadow="sm" mb="4">
              <Text fontSize="15px" fontWeight="700" color="gray.900" borderBottom="1px solid #F1F5F9" pb="3" mb="4">
                Price Breakdown
              </Text>

              <Flex direction="column" gap="3" fontSize="13.5px">
                <Flex justify="space-between">
                  <Text color="gray.600">Total MRP ({cartData.length} items)</Text>
                  <Text fontWeight="600" color="gray.900">₹{sellingPrice}</Text>
                </Flex>

                <Flex justify="space-between">
                  <Text color="gray.600">Discount</Text>
                  <Text fontWeight="600" color="green.600">- ₹{discount}</Text>
                </Flex>

                <Flex justify="space-between">
                  <Text color="gray.600">Applicable GST</Text>
                  <Text fontWeight="600" color="gray.900">₹{gst}</Text>
                </Flex>

                <Flex justify="space-between">
                  <Text color="gray.600">Delivery</Text>
                  <Badge colorScheme="green" variant="subtle" fontSize="11px">FREE</Badge>
                </Flex>

                <Box borderTop="1px dashed #CBD5E1" pt="3" mt="1">
                  <Flex justify="space-between" align="baseline">
                    <Text fontSize="16px" fontWeight="800" color="gray.900">Total Amount</Text>
                    <Text fontSize="20px" fontWeight="800" color="#2563EB">₹{totalAmount}</Text>
                  </Flex>
                </Box>
              </Flex>
            </Box>

            <Flex align="center" gap="3" p="3.5" bg="white" border="1px solid #E2E8F0" rounded="xl" shadow="sm">
              <Icon as={FaTruck} color="#2563EB" boxSize="18px" />
              <Box>
                <Text fontSize="12.5px" fontWeight="700" color="gray.800">
                  Reliable Court Delivery
                </Text>
                <Text fontSize="11px" color="gray.500">
                  Delivered straight to your chamber or residential address
                </Text>
              </Box>
            </Flex>
          </Box>
        </SimpleGrid>
      </Box>
    </Box>
  );
}

export default DeliveryPage;